import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';

import * as actions from './actions';

export function useCookies() {
  const dispatch = useDispatch();

  return bindActionCreators(actions, dispatch);
}
